import baseControllerInput from './baseControllerInput'
const REGEX = [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/]
function buildControllerPhoneExtension({ input, optional }) {
  const baseController = baseControllerInput({
    getErrorMessage: state => {
      const value = state.input.value.replace(/[)(_]/g, '')
      if (!value.length && !optional) {
        return 'Please enter a valid phone extension.'
      }
    },
    maskConfig: {
      mask: REGEX
    }
  })({ input })

  function getStatus() {
    const { valid, value } = baseController.getStatus()
    return {
      valid: optional ? true : valid,
      value
    }
  }
  return { ...baseController, getStatus }
}

export default buildControllerPhoneExtension
